import React from 'react';
import ReportItem from '../ReportItem/ReportItem.js';


export class ReportFeedWidget extends React.Component {
    constructor(props) {
        super(props);

        this.state = { serverErrors: {} };


        console.info('ReportFeedWidget - constructor called.');
    }

    componentWillMount() {
        console.info('ReportFeedWidget - componentWillMount called.');
    }

    componentDidMount() {
        console.info('ReportFeedWidget - componentDidMount called.');

    }

    componentWillReceiveProps(nextProps) {
        console.info('ReportFeedWidget - componentWillReceiveProps called.');

        if (nextProps.lastitem) {
            console.info('ReportFeedWidget - lastitem.');
        }
    }

    shouldComponentUpdate() {
        return true;
    }

    componentWillUpdate() {
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
    }


    onChange(e) {

    }


    render() {
        console.info('ReportFeedPage - render called.');
        if (!this.props.leaderboard) {
            return (<div>Loading leaderboard...</div>);

        }
        let events = this.props.leaderboard.events;
        let items = [];
        events.forEach(element => {
            items.push(<ReportItem key={element.timeinms} data={element} />);
        });
        return items;

    }


}


export default ReportFeedWidget;



// WEBPACK FOOTER //
// ./src/Components/ReportFeedPage/ReportFeedWidget.js